import {
  BarcodeEntry,
  BarcodeQuestionConfig,
  BarcodeResponseState,
} from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';
import { Colors } from '../../../../../themes/colors';
import { RoutineQuestionMessage, RoutineQuestionMessageProps } from '../types';

export const BarcodeQuestionMessage: RoutineQuestionMessage<
  BarcodeQuestionConfig,
  BarcodeResponseState
> = (
  props: RoutineQuestionMessageProps<
    BarcodeQuestionConfig,
    BarcodeResponseState
  >
) => {
  const { t } = useTranslation();
  const { response, question } = props;
  const barcodes = response?.barcodes ?? [];

  if (barcodes.length === 0) {
    return <Text style={props.textStyle}>—</Text>;
  }

  return (
    <View style={styles.container}>
      {barcodes.map((entry: BarcodeEntry, index: number) => (
        <View key={index} style={styles.entry}>
          <View style={styles.entryRow}>
            <Text style={props.textStyle}>{entry.value}</Text>
            {question?.includeQuantity && entry.quantity !== undefined && (
              <Text style={[props.textStyle, styles.quantity]}>
                {t('routines.workflow.execution.barcodeScanner.quantityLabel', {
                  quantity: entry.quantity,
                })}
              </Text>
            )}
          </View>
          {entry.memo ? (
            <Text style={[props.textStyle, styles.memo]}>{entry.memo}</Text>
          ) : null}
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    gap: 4,
  },
  entry: {
    gap: 2,
  },
  entryRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    flexWrap: 'wrap',
  },
  quantity: {
    color: Colors.primaryDark,
    fontStyle: 'italic',
  },
  memo: {
    color: Colors.grayText,
    fontStyle: 'italic',
  },
});
